import { MenuType } from '@/@types/common';
import Permissions from '@/lib/permissions';

const menuRoutes: MenuType[] = [
  {
    path: '/',
    name: 'home',
    ttoken: 'menu.home',
    icon: 'home',
    needPermission: [Permissions.Core],
  },
  {
    path: '/map',
    name: 'map',
    ttoken: 'menu.map',
    icon: 'map',
    needPermission: [Permissions.Core],
  },
  {
    path: '/3d',
    name: 'threed',
    ttoken: 'menu.threed',
    icon: 'public',
    needPermission: [Permissions.ThreeDView],
  },
  {
    path: '',
    name: 'ena',
    ttoken: 'menu.ena',
    icon: 'apartment',
    needPermission: [Permissions.Ena],
    nested: [
      {
        path: '/ena/utility',
        name: 'utility obligations',
        ttoken: 'menu.utility_obligations',
        icon: 'request_page',
        needPermission: [Permissions.Ena],
      },
      {
        path: '/ena/photodoc',
        name: 'photodocumentation',
        ttoken: 'menu.photodoc',
        icon: 'photo_camera',
        needPermission: [Permissions.Ena],
      },
      {
        path: '/ena/kuce-za-odmor',
        name: 'Kuce Za Odmor',
        ttoken: 'menu.kuce_za_odmor',
        icon: 'house',
        needPermission: [Permissions.EnaKuceZaOdmor],
      },
      {
        path: '/ena/porez-na-nekretnine',
        name: 'Porez Na Nekretnine',
        ttoken: 'menu.nekretnine',
        icon: 'real_estate_agent',
        needPermission: [Permissions.EnaViewNekretnine],
      },
      {
        path: '/ena/zalbe',
        name: 'Žalbe',
        ttoken: 'menu.zalbe',
        icon: 'report_problem',
        needPermission: [Permissions.EnaViewNekretnine],
      }
    ],
  },
  {
    path: '',
    name: 'pp',
    ttoken: 'pp:menu.pp',
    icon: 'dashboard',
    needPermission: [Permissions.PPZahtjeviView, Permissions.PPRegistarView],
    nested: [
      {
        path: '/pp/zahtjevi',
        name: 'pp_zahtjevi',
        ttoken: 'pp:menu.pp_zahtjevi',
        icon: 'description',
        needPermission: [Permissions.PPZahtjeviView],
      },
      {
        path: '/pp/registar',
        name: 'pp_registar',
        ttoken: 'pp:menu.pp_registar',
        icon: 'list_alt',
        needPermission: [Permissions.PPRegistarView],
      },
      {
        path: '/pp/registar-karta',
        name: 'pp_registar_karta',
        ttoken: 'pp:menu.pp_registar_karta',
        icon: 'map',
        needPermission: [Permissions.PPRegistarView],
      },
      {
        path: '/pp/statistika',
        name: 'pp_statistika',
        ttoken: 'pp:menu.pp_statistika',
        icon: 'insights',
        needPermission: [Permissions.PPRegistarView],
      },
    ],
  },
  {
    path: '',
    name: 'rasvjeta',
    ttoken: 'menu.rasvjeta',
    icon: 'light',
    needPermission: [Permissions.Rasvjeta],
    nested: [
      {
        path: '/rasvjeta/mjesta',
        name: 'rasvjeta mjesta',
        ttoken: 'menu.rasvjeta_mjesta',
        icon: 'article',
        needPermission: [Permissions.Rasvjeta],
      },
      {
        path: '/rasvjeta/photodoc',
        name: 'rasvjeta photodocumentation',
        ttoken: 'menu.photodoc',
        icon: 'photo_camera',
        needPermission: [Permissions.RasvjetaPhotodoc],
      },
    ],
  },
  {
    path: '',
    name: 'groblja',
    ttoken: 'groblja:menu.groblja',
    icon: 'church',
    needPermission: [Permissions.Groblja],
    nested: [
      // old
      /* {
        path: '/groblja/grobna-mjesta',
        name: 'grobna mjesta',
        ttoken: 'groblja:menu.grobna_mjesta',
        icon: 'article',
        needPermission: [Permissions.Groblja],
      }, */
      // new
      {
        path: '/groblja/popis-groblja',
        name: 'popis groblja  ',
        ttoken: 'groblja:menu.popis_groblja',
        icon: 'article',
        needPermission: [Permissions.Groblja],
      },
      {
        path: '/groblja/registar-umrlih',
        name: 'registar umrlih',
        ttoken: 'groblja:menu.reg_umrlih',
        icon: 'library_books',
        needPermission: [Permissions.GrobljaManageOsnovniRegistri],
      },
      {
        path: '/groblja/registar-kremiranih',
        name: 'registar kremiranih',
        ttoken: 'groblja:menu.reg_kremiranih',
        icon: 'fireplace',
        needPermission: [Permissions.GrobljaManageRegistarKremiranih],
      },
      {
        path: '/groblja/registar-ukopanih',
        name: 'registar ukopanih',
        ttoken: 'groblja:menu.reg_ukopanih',
        icon: 'menu_book',
        needPermission: [Permissions.GrobljaManageOsnovniRegistri],
      },
      {
        path: '/groblja/registar-korisnika',
        name: 'registar korisnika',
        ttoken: 'groblja:menu.reg_korisnika',
        icon: 'person',
        needPermission: [Permissions.GrobljaManageOsnovniRegistri],
      },
      {
        path: '/groblja/registar-grobnih-mjesta-ukopani',
        name: 'registar grobnih mjesta ukopani',
        ttoken: 'groblja:menu.reg_grobnih_mjesta_ukopani',
        icon: 'rectangle',
        needPermission: [Permissions.GrobljaManageOsnovniRegistri],
      },
      {
        path: '/groblja/registar-grobnih-mjesta-korisnici',
        name: 'registar grobnih mjesta korisnici',
        ttoken: 'groblja:menu.reg_grobnih_mjesta_korisnici',
        icon: 'rectangle',
        needPermission: [Permissions.GrobljaManageOsnovniRegistri],
      },
      {
        path: '/groblja/registar-pratecih-gradevina',
        name: 'registar pratecih gradevina',
        ttoken: 'groblja:menu.reg_pratecih_gradevina',
        icon: 'add_business',
        needPermission: [Permissions.GrobljaManageOsnovniRegistri],
      },
      {
        path: '/groblja/upitnici',
        name: 'groblja upitnici',
        ttoken: 'groblja:menu.upitnici',
        icon: 'qr_code_2',
        needPermission: [Permissions.GrobljaUpitnikAdmin],
      },
      {
        path: '/groblja/upitnici/odgovori',
        name: 'groblja upitnik odgovori',
        ttoken: 'groblja:menu.upitnik_odgovori',
        icon: 'fact_check',
        needPermission: [Permissions.GrobljaUpitnikOdgovori],
      },
      {
        path: '/groblja/photodoc',
        name: 'groblja photodocumentation',
        ttoken: 'groblja:menu.photodoc',
        icon: 'photo_camera',
        needPermission: [Permissions.Groblja],
      },
    ],
  },
  {
    path: '',
    name: 'cestovna-infrastruktura',
    ttoken: 'menu.cestovna_infrastruktura',
    icon: 'directions_car',
    needPermission: [Permissions.CestovnaInfrastruktura],
    nested: [
      {
        path: '/cestovna-infrastruktura/ceste-putevi',
        name: 'ceste-i-putevi',
        ttoken: 'menu.ceste_i_putevi',
        icon: 'route',
        needPermission: [Permissions.CestovnaInfrastruktura],
      },
      {
        path: '/cestovna-infrastruktura/tocke-interesa',
        name: 'tocke-interesa',
        ttoken: 'menu.tocke_interesa',
        icon: 'location_pin',
        needPermission: [Permissions.CestovnaInfrastruktura],
      },
      {
        path: '/cestovna-infrastruktura/aktivnosti-odrzavanja',
        name: 'aktivnosti-odrzavanja',
        ttoken: 'menu.aktivnosti_odrzavanja',
        icon: 'engineering',
        needPermission: [Permissions.CestovnaInfrastruktura],
      },
    ],
  },
  {
    path: '/nerazvrstane-ceste',
    name: 'nerazvrstane-ceste',
    ttoken: 'menu.nerazvrstane_ceste',
    icon: 'remove_road',
    needPermission: [Permissions.NerazvrstaneCeste],
  },
  {
    path: '/koncesije',
    name: 'koncesije',
    ttoken: 'koncesije:menu.koncesije',
    icon: 'set_meal',
    needPermission: [Permissions.KoncesijeView],
  },
  {
    path: '/plin/zatvaranje-ventila',
    name: 'zatvaranje-ventila',
    ttoken: 'plin:menu.zatvaranje_ventila',
    icon: 'local_fire_department',
    needPermission: [Permissions.PlinSimulacijeVentila],
  },
  {
    path: '/parking',
    name: 'parking',
    ttoken: 'menu.parking',
    icon: 'local_parking',
    needPermission: [Permissions.Parking],
  },
  {
    path: '/pristupacnost',
    name: 'pristupacnost',
    ttoken: 'pristupacnost:menu.pristupacnost',
    icon: 'accessibility',
    needPermission: [Permissions.PristupacnostViewGrades],
    nested: [
      {
        path: '/pristupacnost/evaluacije',
        name: 'evaluacije',
        ttoken: 'pristupacnost:menu.evaluacija_objekata',
        icon: 'grade',
        needPermission: [Permissions.PristupacnostViewGrades],
      },
       {
        path: '/pristupacnost/poi',
        name: 'tocke_interesa',
        ttoken: 'pristupacnost:menu.poi',
        icon: 'location_pin',
        needPermission: [Permissions.PristupacnostViewGrades],
      },
    ],
  },
  {
    path: '/comments',
    name: 'comments',
    ttoken: 'menu.comments',
    icon: 'comment',
    needPermission: [Permissions.Private],
  },
  {
    path: '/user-tenants',
    name: 'user-tenants',
    ttoken: 'menu.user_tenants',
    icon: 'people',
    needPermission: [Permissions.TenantUserAdministration],
  },
  {
    path: '/admin',
    name: 'administration',
    ttoken: 'menu.admin',
    icon: 'build',
    needPermission: [Permissions.Administration],
    nested: [
      {
        path: '/admin/tenants',
        name: 'tenants',
        ttoken: 'menu.tenants',
        icon: 'business',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/users',
        name: 'users',
        ttoken: 'menu.users',
        icon: 'people',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/translations',
        name: 'translations',
        ttoken: 'menu.translations',
        icon: 'translate',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/models',
        name: 'models',
        ttoken: 'menu.models',
        icon: 'auto_awesome_motion_icon',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/map_layers',
        name: 'map_layers',
        ttoken: 'admin:menu.map_layers',
        icon: 'layers',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/map_legends',
        name: 'Map Legends',
        ttoken: 'admin:menu.map_legends',
        icon: 'signpost',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/registar-prostornih-planova',
        name: 'Registar prostornih planova',
        ttoken: 'admin:menu.registar_prostornih_planova',
        icon: 'map',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/comments',
        name: 'Admin Comments',
        ttoken: 'admin:menu.comments',
        icon: 'rate_review',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/dynamic_forms',
        name: 'Admin Dynamic Forms',
        ttoken: 'admin:menu.dynamic_forms',
        icon: 'book',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/3d_settings',
        name: '3D Settings',
        ttoken: 'admin:menu.3d_settings',
        icon: 'view_in_ar',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/ena_settings',
        name: 'Ena Settings',
        ttoken: 'admin:menu.ena_settings',
        icon: 'room_preferences',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/search_settings',
        name: 'Search Settings',
        ttoken: 'admin:menu.search_settings',
        icon: 'search',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/app_logs',
        name: 'App Logs',
        ttoken: 'admin:menu.app_logs',
        icon: 'storage',
        needPermission: [Permissions.Administration],
      },
      {
        path: '/admin/login_logs',
        name: 'Login Logs',
        ttoken: 'admin:menu.login_logs',
        icon: 'key',
        needPermission: [Permissions.Administration],
      },
    ],
  }
];

export default menuRoutes;
